import './spinner.scss';

class Spinner {
	constructor(element, options = {}) {
		this.element = element;
		this.options = Object.assign({}, options);

		this.spinner = this.insert();
	}

	insert() {
		const tmp = document.createElement('div');
		const spinner = `<svg class="ln-spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
	<circle class="ln-spinner__path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;

		tmp.innerHTML = spinner;

		return this.element.appendChild(tmp.firstChild);
	}

	enable() {
		this.element.disabled = true;

		this.element.classList.add('is-loading');
		this.spinner.classList.add('is-active');
	}

	disable() {
		this.element.disabled = false;

		this.element.classList.remove('is-loading');
		this.spinner.classList.remove('is-active');
	}
}

export default Spinner;
